import API from "../Common/Endpoint/serviceConstrants";
import axiosIntegration from "../Common/Axios/axiosIntegration";
export const enrollmentApi = async (payload) => {
  const { data = {} } = await axiosIntegration.post(
    API.Enrollment,
    payload
  );
  return data;
};
